<template>
  <div
    v-if="selectedItem"
    class="content-container"
  >
    <div class="content">
      <div class="content-item">
        <label>Name
          <span
            class="text-danger"
          >*</span>
        </label>
        <b-form-input
          v-model="selectedItem.name"
          :disabled="!selectedItem.editable"
          class="input-field"
        />
      </div>

      <div class="content-item">
        <label>Icon
          <span
            class="text-danger"
          >*</span>
        </label>
        <div
          v-if="!selectedItem.icon"
          class="icon-box"
        />
        <font-awesome-icon
          v-else
          :icon="['fas', selectedItem.icon]"
        />
        <vfa-picker
          v-model="selectedItem.icon"
          :only="onlyIcons"
          class="icon-select-input"
        >
          <template #activator="{ on }">
            <b-button
              id="selectFolderIconBtn"
              variant="warning"
              :disabled="!selectedItem.editable"
              @click="on"
            >
              Choose Icon
            </b-button>
          </template>
        </vfa-picker>
      </div>

      <div class="content-item">
        <label>Visible</label>
        <b-form-checkbox
          v-model="selectedItem.visible"
          :disabled="!selectedItem.editable"
          class="checkbox-field"
        />
      </div>
    </div>
    <div class="subitems">
      <sub-item-list />
    </div>
  </div>
</template>
<script>

import SubItemList from './SubItemList.vue';
import { createNamespacedHelpers } from 'vuex';

const {
  mapState: leftNavCustomizationMapState,
} = createNamespacedHelpers('leftNavCustomization');

const {mapState} = createNamespacedHelpers('dataManagement');

export default {
  name: 'ItemContent',
  components: {
    SubItemList,
  },
  data(){
    return{
      isLoading: false,
    };
  },
  computed: {
    ...mapState(['onlyIcons']),
    ...leftNavCustomizationMapState({
      selectedItem: state => state.selectedNavItem,
    }),
  },
};
</script>
<style scoped lang="scss">
.content-container{
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: 1fr;
  overflow: hidden;
}
.content {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.subitems{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  overflow: hidden;
  position: relative;
}

.content-item {
  display: flex;
  align-items: center;
  margin-right: 20px; /* Space between each item */
}

label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-right: 8px; /* Space between label and input */
}

.input-field {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 250px; /* Reasonable width for input */
}

.icon-button {
  padding: 6px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #f5f5f5;
  cursor: pointer;
  font-size: 14px;
}

.checkbox-field {
  margin-right: 8px;
}

span {
  font-size: 14px;
  color: #555;
}
.icon-box {
  margin-right: 8px;
  width: 20px;
  height: 20px;
  background: #ddd;
  border: 1px dashed #aaa;
  display: inline-block;
  vertical-align: middle;
}
label{
  padding:8px;
  margin:0px;
}
.icon-select-input{
  margin-left:8px;
}

.submit-btn{
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  // svg{
  //   margin-right: 10px;
  // }
}
</style>